import { render, staticRenderFns } from "./ReferralForServiceModal.vue?vue&type=template&id=2e19dc60&"
import script from "./ReferralForServiceModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReferralForServiceModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e19dc60')) {
      api.createRecord('2e19dc60', component.options)
    } else {
      api.reload('2e19dc60', component.options)
    }
    module.hot.accept("./ReferralForServiceModal.vue?vue&type=template&id=2e19dc60&", function () {
      api.rerender('2e19dc60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InvasiveServiceInfo/components/ReferralForServiceModal.vue"
export default component.exports